import type { TaskTitle } from '@pa/core';
import type { TFunction } from 'i18next';

type Tx = TFunction;

/**
 * The words for a task or timeline title (M5.2): the label in the UI language, the person's
 * content as the subject. There is no generic verb: an unknown title still names the tool.
 */
export function titleLabel(title: TaskTitle, t: Tx): string {
  return t(`tasks.title.${title.key}`, { defaultValue: t('tasks.title.action') });
}

/** "Create event: «تفاصيل منتجات فايبر»" as plain text (tests and titles); the UI isolates the subject. */
export function titleText(title: TaskTitle, t: Tx): string {
  const label = titleLabel(title, t);
  return title.subject ? `${label}: «${title.subject}»` : label;
}
